"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.onRouteUpdate = exports.onClientEntry = void 0;

var _merge = _interopRequireDefault(require("lodash/merge"));

var _defaultOptions = _interopRequireDefault(require("./default-options"));

var _index = require("./index");

// init
var onClientEntry = function onClientEntry(_, pluginOptions) {
  if (pluginOptions === void 0) {
    pluginOptions = {};
  }

  var options = (0, _merge.default)(_defaultOptions.default, pluginOptions);
  window.gatsbyPluginGDPRCookiesOptions = options;
  (0, _index.initializePlugin)(options);
}; // track


exports.onClientEntry = onClientEntry;

var onRouteUpdate = function onRouteUpdate(_ref, pluginOptions) {
  var location = _ref.location;

  if (pluginOptions === void 0) {
    pluginOptions = {};
  }

  var options = (0, _merge.default)(_defaultOptions.default, pluginOptions);
  (0, _index.trackVisit)(options, location);
};

exports.onRouteUpdate = onRouteUpdate;